var AnalyticsUniqueCustomers = /** @class */ (function () {
    function AnalyticsUniqueCustomers() {
        this.uniqueLoggedInCustomers = 0;
        this.guestCustomers = 0;
    }
    return AnalyticsUniqueCustomers;
}());
export default AnalyticsUniqueCustomers;
